var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4821 148.6474",
    enableBackground: "new 0 0 113.4821 148.6474",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 87.7164,
    cy: 23.4736,
    r: 16,
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0777,88.4043v3.4912c0,3.3086-2.6944,6-6.0029,6H64.8443c-0.2402,3.2637-0.3779,6.3457-0.3779,9.1162 c0,1.0703,3.2363,1.8584,8,2.3642v32.7715c0,3.5899,2.9101,6.5,6.5,6.5c3.5898,0,6.5-2.9101,6.5-6.5v-32.1045 c1.496,0.0166,3.0039,0.0166,4.5,0v32.1045c0,3.5899,2.9101,6.5,6.5,6.5c3.5898,0,6.5-2.9101,6.5-6.5v-32.7715 c4.7636-0.5058,8-1.2939,8-2.3642c0-8.8218-1.3926-20.7827-3.0332-31.8154c-4.8799,4.4809-12.0967,8.7138-22.0586,12.9301 C85.6138,88.2373,85.3472,88.3261,85.0777,88.4043z",
    id: "id_102",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0748,53.8935c3.3085,0,6.0019,2.6914,6.0029,6v13.2627c7.3847-3.4775,11.3359-6.3613,13.3984-8.2837 c1.3594-1.2754,2.9883-3.0966,3.0049-4.4809l1.9981,0.0034c0.0009,0.0068,0.0019,0.0132,0.0019,0.02 c-0.0127,1.0449-0.4189,2.8911-3.6416,5.9224c-3.1885,2.9707-9.0664,6.7046-18.6338,10.7353 c-2.5449,1.0723-3.7363,4.0054-2.6601,6.5503c0.8066,1.9097,2.6582,3.0571,4.6074,3.0571c0.6484,0,1.3076-0.1269,1.9433-0.3955 c10.2198-4.3261,17.0079-8.434,21.5371-12.6084c4.4961-4.1157,6.8633-8.7221,6.8487-13.2612c0-0.001,0-0.0015,0-0.0019 c0.0029-2.8487-0.918-5.3706-2.1211-7.358c-1.8233-2.9956-4.2119-4.9985-6.1231-6.3818c-1.9209-1.3682-3.4189-2.0859-3.6005-2.1758 c-0.3506-0.1674-0.712-0.2793-1.0762-0.3598c-2.083-0.899-5.9649-1.9239-12.8447-1.9239c-5.6983,0-9.3233,0.7041-11.5889,1.4561 c-1.5039,0.4087-6.2061,2.1704-11.0068,8.0185c-0.5586,0.6778-1.1172,1.42-1.6729,2.2051H79.0748z",
    id: "id_103",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2925,
    cy: 17.5,
    r: 17.5,
    id: "id_104",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0767,97.8955c-3.3105-0.001-6.001-2.6914-6.0019-6v-6.5039c-0.2354-0.0552-0.4737-0.1001-0.7032-0.1797 c-7.206-2.4898-13.0127-5.1519-17.5791-8.0615V140.5c0,4.4179,3.5821,8,8,8c4.418,0,8-3.5821,8-8v-41h3v41c0,4.4179,3.5821,8,8,8 c4.418,0,8-3.5821,8-8V97.8955H35.0767z",
    id: "id_105",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0757,95.8945l44,0.001c2.209-0.001,4-1.791,4-4v-3.2217c-2.7871-0.0312-5.2851-1.6973-6.372-4.2725 c-0.7295-1.7226-0.7442-3.625-0.0401-5.3584c0.7041-1.7329,2.0401-3.0864,3.7647-3.8149c0.9287-0.3911,1.8008-0.7739,2.6474-1.1528 V59.8955c0-2.209-1.791-4-4-4h-44c-2.209,0-4,1.791-4,4v11.4253c0.5996,0.2173,1.2139,0.436,1.8535,0.6552 c1.7686,0.608,3.1944,1.8682,4.0137,3.5499c0.8194,1.6796,0.9365,3.581,0.3272,5.3476c-0.9258,2.6885-3.3858,4.5161-6.1944,4.6875 v6.3345C31.0757,94.1045,32.8667,95.8955,35.0757,95.8945z M76.8257,59.6455h2.5v2.5h-2.5V59.6455z",
    id: "id_106",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9966,71.8427c4.6807,4.1358,11.6377,7.8887,22.0274,11.4786c0.539,0.186,1.0879,0.2739,1.6279,0.2739 c2.0752,0,4.0137-1.3013,4.7275-3.374c0.8985-2.6099-0.4902-5.4561-3.1005-6.355c-9.6329-3.3028-15.5-6.688-18.6397-9.499 c-3.1543-2.8765-3.5937-4.7163-3.6377-6.1753c0-0.0044,0.001-0.0093,0.001-0.0142c-0.0293-0.8769,0.2724-1.8882,0.79-2.9175v3.2085 c0.5049,0.6421,1.9033,2.333,4.1944,4.4209c1.7265,1.5459,5.748,4.4541,14.0879,7.6826V59.8935c0-3.3086,2.6914-6,6.0009-6h21.2168 c-0.9092-2.166-1.8642-4.0283-2.8379-5.6123c-4.1845-6.8965-9.0547-8.5322-10.3173-8.6831 c-0.503-0.0869-0.9961-0.0718-1.4766-0.0107C41.3775,39.5376,41.0894,39.5,40.7925,39.5h-25c-0.2959,0-0.583,0.0376-0.8652,0.0869 c-1.1016-0.1401-2.2529,0.061-3.2686,0.6948h-0.0019c-0.2168,0.1426-2.8291,1.7608-5.6192,4.6704 c-2.7207,2.8867-5.9614,7.2315-6.0361,13.2217c0,0.0059-0.001,0.0117-0.001,0.0181C-0.0405,62.8589,2.3316,67.7734,6.9966,71.8427z ",
    id: "id_107",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon06);
export default __webpack_public_path__ + "static/media/feature-tile-icon-06.afbccb7b624531619831c9b2f44e5354.svg";
export { ForwardRef as ReactComponent };